import { render, staticRenderFns } from "./tietie.vue?vue&type=template&id=f5ec8ac6&scoped=true&"
import script from "./tietie.vue?vue&type=script&lang=js&"
export * from "./tietie.vue?vue&type=script&lang=js&"
import style0 from "./tietie.vue?vue&type=style&index=0&id=f5ec8ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ec8ac6",
  null
  
)

export default component.exports